// extracted by mini-css-extract-plugin
export default {"projectWrapper":"project_projectWrapper__Z1Jgj","projectBackground":"project_projectBackground__v2A9D","projectTop":"project_projectTop__59wWn"};